/* eslint-disable */
import { connect } from 'react-redux';
import { headCells, memberFilters, mockMemberTableData } from './data/mockData'
import NewTeamMembers from './NewTeamMembers';
// import { getMemberDetails, filterAction } from '../../Store/actions';

// const mapActionCreators = {
//   getMemberDetails,
//   filterAction,
// };

const mapStateToProps = (state) => ({
  memberList: {},
  count: 4,
  headCells,
  memberFilters,
});

export default connect(mapStateToProps, )(NewTeamMembers);



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/container.js